var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "fill-none",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 171.25 10.68",
      },
    },
    [
      _c("polyline", {
        staticClass: "stroke-2",
        attrs: {
          points:
            "0.63 9.28 10.63 1.28 20.63 9.28 30.63 1.28 40.63 9.28 50.63 1.28 60.63 9.28 70.63 1.28 80.63 9.28 90.63 1.28 100.63 9.28 110.63 1.28 120.63 9.28 130.63 1.28 140.63 9.28 150.63 1.28 160.63 9.28 170.63 1.28",
        },
      }),
      _vm._v(" "),
      _c("polyline", {
        attrs: { points: "4.13 10.28 10.63 5.28 17.13 10.28" },
      }),
      _vm._v(" "),
      _c("polyline", {
        attrs: { points: "24.13 10.28 30.63 5.28 37.13 10.28" },
      }),
      _vm._v(" "),
      _c("polyline", {
        attrs: { points: "44.13 10.28 50.63 5.28 57.13 10.28" },
      }),
      _vm._v(" "),
      _c("polyline", {
        attrs: { points: "64.13 10.28 70.63 5.28 77.13 10.28" },
      }),
      _vm._v(" "),
      _c("polyline", {
        attrs: { points: "84.13 10.28 90.63 5.28 97.13 10.28" },
      }),
      _vm._v(" "),
      _c("polyline", {
        attrs: { points: "104.13 10.28 110.63 5.28 117.13 10.28" },
      }),
      _vm._v(" "),
      _c("polyline", {
        attrs: { points: "124.13 10.28 130.63 5.28 137.13 10.28" },
      }),
      _vm._v(" "),
      _c("polyline", {
        attrs: { points: "144.13 10.28 150.63 5.28 157.13 10.28" },
      }),
      _vm._v(" "),
      _c("line", {
        attrs: { x1: "164.12", y1: "10.28", x2: "170.62", y2: "5.28" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }